import Hero from "./components/hero";
import Nav from "./components/nav";
import Section from "./components/section";
import Section2 from "./components/section2";
import Contact from "./components/contact";
import Section3 from "./components/section3";
import Section4 from "./components/section4";
import AcademySection from "./components/AcademySection";
import { useMediaQuery } from "@mui/material";

function App() {
  const isMobile = useMediaQuery("(max-width:768px)");
  return (
    <div className="bg-[#fefefe] w-full font-mont">
    <Nav></Nav>
    <Hero></Hero>
    <Section></Section>
    <Section2></Section2>
    <Section3></Section3>
    <Section4></Section4>
    <AcademySection></AcademySection>
    <Contact></Contact>
    </div>
  );
}

export default App;
